export const odeFundingSources = [
  { label: "Amigos y familia", value: "FRIENDS_AND_FAMILY" },
  { label: "Inversionista ángel", value: "ANGEL_INVESTORS" },
  { label: "Fondo de inversión", value: "INVESTMENT_FUND" },
  { label: "Inversionista privado", value: "PRIVATE_INVESTOR" },
  { label: "Concurso", value: "CONTEST" },
  { label: "Otro", value: "OTHER" }
];
